import Divider from "./components/Divider";
import Header from "./components/Header";
import FollowUpHistoryList from "./components/List/FollowUpHistoryList";
import useFollowUpHistory from "./hooks/useFollowUpHistory";

export default function FollowUpHistory({ caseObj }) {
  const caseId = caseObj?.id ?? caseObj?.pk;
  const { isLoading, data, showMore, fetchData } = useFollowUpHistory({ caseId });

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-hidden p-4">
      <div className="relative">
        <Header />
        <Divider />
      </div>
      <div className="relative flex-1">
        <FollowUpHistoryList
          data={data}
          isLoading={isLoading}
          showMore={showMore}
          handleShowMore={() => fetchData()}
        />
      </div>
    </div>
  );
}
